import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchDepartments = createAsyncThunk(
    "departments/fetchDepartments",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("api/auth/departments");
            const result = response.data;
            return result?.data?.departments || result?.departments || (Array.isArray(result) ? result : []);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
